"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusControl = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

var _utils = require("../../utils");

// This hook handles arrow navigation for focusable components
var useFocusControl = function useFocusControl(_ref) {
  var onBlur = _ref.onBlur,
      elements = _ref.elements;
  var elementSet = (0, _react.useRef)(new Set(elements));
  var lastFocusedElement = (0, _react.useRef)();

  var clickHandler = function clickHandler(e) {
    if (e.target) {
      lastFocusedElement.current = e.target;
    } // Preventing focus on clicked buttons


    e.preventDefault();
  };

  var setFocusOnClick = function setFocusOnClick(el) {
    el.removeEventListener('mousedown', clickHandler);
    el.addEventListener('mousedown', clickHandler);
  };

  var setFocusable = function setFocusable(el) {
    return el.setAttribute('tabindex', '0');
  };

  var setUnfocusable = function setUnfocusable(el) {
    return el.setAttribute('tabindex', '-1');
  };

  var keyHandler = (0, _react.useCallback)(function (e) {
    // Preventing scrolling on pressed up/down keys
    if ([_utils.EventKeys.ARROW_UP, _utils.EventKeys.ARROW_DOWN].includes(e.key)) {
      e.preventDefault();
      e.stopPropagation();
    }

    if ([_utils.EventKeys.ARROW_LEFT, _utils.EventKeys.ARROW_RIGHT].includes(e.key)) {
      var elementsArray = (0, _toConsumableArray2.default)(elementSet.current);
      var focusedIndex = elementsArray.findIndex(function (el) {
        return el === (0, _utils.getActiveElement)(el, {
          closedShadowDom: true
        });
      }); // If nothing focused we take last focused element or first element

      if (focusedIndex === -1) {
        if (lastFocusedElement.current) {
          focusedIndex = elementsArray.indexOf(lastFocusedElement.current);
        } else {
          focusedIndex = 0;
        }
      } // Setting element tabindex -1 to make it unfocusable for tabbing


      setUnfocusable(elementsArray[focusedIndex]);
      focusedIndex = e.key === _utils.EventKeys.ARROW_LEFT ? focusedIndex - 1 : focusedIndex + 1;

      if (focusedIndex > elementsArray.length - 1) {
        focusedIndex = 0;
      } else if (focusedIndex < 0) {
        focusedIndex = elementsArray.length - 1;
      }

      var newFocusElement = elementsArray[focusedIndex];
      newFocusElement.focus();
      setFocusable(newFocusElement); // Saving focused element

      lastFocusedElement.current = newFocusElement;
    }

    if (e.key === _utils.EventKeys.ESCAPE && onBlur) {
      onBlur();
    }
  }, [onBlur, elementSet]); // Method to add and modify elements

  var storeRef = function storeRef(ref) {
    if (ref && !ref.disabled) {
      setUnfocusable(ref);
      setFocusOnClick(ref);
      elementSet.current.add(ref);
    }
  }; // Method to focus previous focused element


  var focusPreviousElement = (0, _react.useCallback)(function () {
    if (lastFocusedElement.current && elementSet.current.has(lastFocusedElement.current)) {
      lastFocusedElement.current.focus();
    } else if (elementSet.current.size > 0) {
      var _elementSet$current = (0, _slicedToArray2.default)(elementSet.current, 1),
          firstElement = _elementSet$current[0];

      firstElement.focus();
    }
  }, [elementSet]); // Sorting elements in a case if any of them unmounted/removed from DOM Tree

  (0, _react.useEffect)(function () {
    if (elementSet.current) {
      var sortedElements = (0, _toConsumableArray2.default)(elementSet.current).filter(function (el) {
        return el.offsetLeft > 0;
      }).sort(function (a, b) {
        return a.offsetLeft - b.offsetLeft;
      });
      elementSet.current = new Set(sortedElements);
    }
  }, [elementSet.current.size]);
  return {
    storeRef: storeRef,
    keyHandler: keyHandler,
    focusPreviousElement: focusPreviousElement
  };
};

exports.useFocusControl = useFocusControl;